// /centers 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 7개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값은 기존과 100% 동일.

import type { SearchFieldConfig } from "components/list";

export const centersSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID에서 검색", type: "text", operator: "contains", width: 160 },
  { name: "name", label: "이름에서 검색", type: "text", operator: "contains", width: 200 },
  {
    name: "kindOf",
    label: "종류",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "ChildHouse", label: "어린이집" },
      { value: "Kindergarten", label: "유치원" },
      { value: "Dementia", label: "치매" },
      { value: "IDisabled", label: "지적장애" },
    ],
  },
  { name: "address", label: "주소에서 검색", type: "text", operator: "contains", width: 220 },
  { name: "tel", label: "전화번호에서 검색", type: "text", operator: "contains", width: 200 },
  {
    name: "estType",
    label: "유형",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "NATIONAL", label: "국립" },
      { value: "PUBLIC_ATTACHED", label: "공립(병설)" },
      { value: "PUBLIC_STANDALONE", label: "공립(단설)" },
      { value: "PRIVATE_CORP", label: "사립(법인)" },
      { value: "PRIVATE_INDIVIDUAL", label: "사립(사인)" },
      { value: "NATIONAL_PUBLIC", label: "국공립" },
      { value: "SOCIAL_WELFARE", label: "사회복지법인" },
      { value: "CORP_ORGS", label: "법인·단체등" },
      { value: "CIVIL", label: "민간" },
      { value: "HOME", label: "가정" },
      { value: "COOPERATIVE", label: "협동" },
      { value: "WORKPLACE", label: "직장" },
    ],
  },
  {
    name: "status",
    label: "상태",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "OPENED", label: "정상" },
      { value: "CLOSED", label: "폐지" },
      { value: "PAUSED", label: "휴지" },
      { value: "REOPENED", label: "재개" },
    ],
  },
];
